import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer as HotLoaderContainer } from 'react-hot-loader';
import store from '@/store';
import Pages from './pages';

const isHMR = process.env.npm_lifecycle_event === 'hot';
const rootElement = document.querySelector('#root');
const AppContainer = isHMR ? HotLoaderContainer : React.Fragment;
import styles from './index.module.css';

const renderApp = () => {
  render(
    <AppContainer >
      <Provider store={store} >
        <Pages />
      </Provider>
    </AppContainer>,
    rootElement
  );
};

renderApp(rootElement);

if ( module.hot ) module.hot.accept();
